import { axiosInstance } from "@retro-ia/shared/axios";
import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from "@tanstack/react-query";
import { toast } from "sonner";

interface UseDeleteLogicoUsuarioProps {
  queryKey: QueryKey;
}

export const useDeleteLogicoUsuario = ({
  queryKey,
}: UseDeleteLogicoUsuarioProps) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number | string) => {
      const res = await axiosInstance.put(`/usuarios/${id}`, undefined, {
        withCredentials: true,
      });
      return res.data;
    },
    onSuccess: () => {
      toast.success("El usuario fue eliminado.");
      queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      toast.error("Error al desactivar");
    },
  });
};
